import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash,
        behavior: 'smooth'
      }
    }
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '*',
      redirect: '/'
    }, {
      path: '/',
      name: 'PageView',
      component: resolve => require(['@/view/PageView'], resolve),
      children: [
        {
          path: '/',
          redirect: '/home'
        },
        {
          path: '/home',
          name: 'home',
          component: resolve => require(['@/view/HomePage'], resolve),
          meta: {
            title: '紧固达'
          }
        },
        {
          path: '/home',
          name: 'software',
          component: resolve => require(['@/view/HomePage'], resolve),
          meta: {
            title: '功能分区'
          },
          // children: [
          //   {
          //     path: '/software',
          //     redirect: '/software/smartTown'
          //   },
          //   {
          //     path: '/software/smartTown',
          //     name: 'software',
          //     component: resolve => require(['@/view/Software_smartTown'], resolve),
          //     meta: {
          //       title: '功能分区丨紧固达'
          //     }
          //   }
          // ]
        },
        {
          path: '/home',
          name: 'service',
          component: resolve => require(['@/view/HomePage'], resolve),
          meta: {
            title: '园区服务'
          }
        },
        {
          path: '/home',
          name: 'newsinformation',
          component: resolve => require(['@/view/HomePage'], resolve),
          meta: {
            title: '新闻咨询'
          }
        },
        {
          path: '/home',
          name: 'companyintroduction',
          component: resolve => require(['@/view/HomePage'], resolve),
          meta: {
            title: '可持续发展'
          }
        },
        {
          path: '/home',
          name: 'jobchance',
          component: resolve => require(['@/view/HomePage'], resolve),
          meta: {
            title: '入住企业'
          }
        },
        {
          path: '/home',
          name: 'contactus',
          component: resolve => require(['@/view/ContactUs'], resolve),
          meta: {
            title: '合作咨询'
          }
        }
      ]
    }
  ]
})




// WEBPACK FOOTER //
// ./src/router/index.js